import { defineComponent as _defineComponent } from 'vue'
import RestrictDialog from '@/components/RestrictDialog.vue';
import DataDoesNotExist from '@/components/DataDoesNotExist.vue';
import {getPushProcessingDetail, getDealWithList, dealWithConcat} from '@/api/miscellaneous';
import {useRoute, useRouter} from 'vue-router';
import {ref} from 'vue';
import {Toast} from 'vant';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProcessDetail',
  setup(__props, { expose }) {
  expose();

const route = useRoute();
const router = useRouter();

const detail = ref<any>({});

const tel = ref(false);
const isShowTel = ref(false);
const restrictShow = ref(false);
const restrictCode = ref('');

const isDataExist = ref(false);

const getListData = ref({
    id: route.query.id as string,
    page: 1,
    size: 10,
    categoryId: '',
});
const list = ref<any[]>([]);
const listLoading = ref(false);
const finished = ref(false);

const getDetail = (id?: string) => {
    id = id ?? (route.query.id as string) ?? (route.query.state as string);
    getPushProcessingDetail({id}).then((res: any) => {
        // images.value = res.data.images;
        if (res.online) {
            detail.value = res;
            getListData.value.categoryId = res.categoryId;
            getList();
        } else {
            isDataExist.value = true;
        }
    });
};
getDetail();

const getList = () => {
    getDealWithList(getListData.value).then((res: any) => {
        list.value = [...list.value, ...res.items];
        listLoading.value = false;
        getListData.value.page++;
        finished.value = getListData.value.page * getListData.value.size >= res.totalCount;
    });
};

const getTel = (id: string) => {
    id = id || (route.query.id as string) || '';
    console.log(id);
    dealWithConcat({id})
        .then(res => {
            tel.value = res;
            isShowTel.value = true;
        })
        .catch(e => {
            let {code} = e;
            if ([120, 121].includes(code)) {
                restrictCode.value = code;
                restrictShow.value = true;
            }
        });
};

const refresh = (item: any) => {
    router.push({name: 'ProcessingDetails', query: {id: item.id}});
    getDetail(item.id);
};

const __returned__ = { route, router, detail, tel, isShowTel, restrictShow, restrictCode, isDataExist, getListData, list, listLoading, finished, getDetail, getList, getTel, refresh, RestrictDialog, DataDoesNotExist, getPushProcessingDetail, getDealWithList, dealWithConcat, useRoute, useRouter, ref, Toast }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})